ApplicationSerializer = require './application'

App.StaffMemberSerializer = ApplicationSerializer.extend DS.EmbeddedRecordsMixin,
  attrs:
    restaurants: serialize: 'ids'
    cooking_lines: serialize: 'ids'
